module.exports = __webpack_public_path__ + "static/media/customcookie.29107a28.png";